import { render, staticRenderFns } from "./BlockPersons.vue?vue&type=template&id=4ab68d50&"
import script from "./BlockPersons.vue?vue&type=script&lang=js&"
export * from "./BlockPersons.vue?vue&type=script&lang=js&"
import style0 from "./BlockPersons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports